import NoSSR from 'react-no-ssr'
import { useContext } from 'react'
import { Separator } from '@components'

import styled from 'styled-components'
import { AddToCollectionContext } from '@components/collections/AddToCollection'

import { Container, Col, SharingButton, ButtonIcon, Row } from '@mch-group/uikit-components'
import useRequestLabels from '@hooks/useRequestLabels'
import { useModuleContext } from '../../contexts/ArtistContext'

import CatalogueArtworkView from './CatalogueArtworkView'

import Profile from './Profile'
import ArtistGalleries from './ArtistGalleries'
import useImageDimensions from '../../hooks/useImageDimensions'
import { PageContext } from '@providers/PageContext'
import ReadMoreWithCSSClamp from '@components/ReadmoreWithCSSClamp'


const ArtistDetail = () => {
  useRequestLabels(['ArtistDetail'], useModuleContext)
  const { page: { pageData } } = useContext(PageContext)
  const { name, id, mostRelevanceArtwork, profileImageUrl, biography } = pageData
  // @ts-ignore
  const { state: { CMSProps, labels } } = useModuleContext()
  const { imageDimensions } = useImageDimensions()
  const artistHeroImage = profileImageUrl ? profileImageUrl : mostRelevanceArtwork?.imageUrlLatestUploadedArtwork
  const { showAddToCollectionModal } = useContext(AddToCollectionContext)

  return (
    <>
      <ArtistHeader className='mt-0 mt-xl-8' id='header-row'>
        <Container className='px-0 ps-xl-8'>
          <Row>
            <Col className='col-12 col-md-10 col-xl-5 order-2 order-xl-1'>
              <div className='d-flex justify-content-md-start mt-5 mt-md-3 mt-xl-8 mx-5 mx-md-7 mx-xl-0 mb-7 mb-md-10 mb-xl-0'>
                <div className='me-3'>
                  <NoSSR>
                    <SharingButton
                      title='Share'
                      media={[
                        'facebook',
                        'whatsapp',
                        'linkedin',
                        'twitter',
                        'weebo',
                        'wechat',
                        'mail',
                        'link-default'
                      ]}
                      variant='outline'
                      theme='dark'
                    />
                  </NoSSR>
                </div>
                <ButtonIcon
                  title='Add to Collection'
                  icon='collections-add'
                  variant='outline'
                  // @ts-ignore
                  onClick={() => showAddToCollectionModal(id, 3)}
                  theme='dark'
                />
              </div>
              <div className='artist-info mx-5 mx-md-7 mx-xl-0 mb-8 mb-md-9 mb-xl-0'>
                <div className='header-uppercase-2 mb-3 h1'>
                  {labels?.ArtistDetail.artistLabel}
                </div>
                <h1>{name}</h1>
              </div>
            </Col>
            <Profile
              // @ts-ignore
              imageDimensions={imageDimensions}
              artistHeroImage={artistHeroImage}
              isArtworkData={true}
            />
          </Row>
        </Container>
      </ArtistHeader>
      {biography &&
        <>
          <div id='artist-description'>&nbsp;</div>
          <main className='mb-9 mb-md-10 mb-xl-12 mb-xxl-13'>
            <Container className='px-5 px-xl-8 px-md-7'>
              <Row className='mt-0'>
                <Col className='col-12 col-md-10 col-xl-5 mt-md-7 mt-lg-9 mt-xl-9 mt-xxl-10'>
                  <h2 className='h3'>{labels?.ArtistDetail.bioLabel}</h2>
                </Col>
                <Col className='col-md-10 col-xl-7 xl-6 mt-md-3 mt-lg-9 mt-xl-9 mt-xxl-10'>
                  <ReadMoreWithCSSClamp
                    text={biography}
                    onFoldCallback={() => {
                      const descriptionEl = document.getElementById('artist-description')
                      descriptionEl && descriptionEl.scrollIntoView({ behavior: 'smooth' })
                    }}
                    labels={{
                      unfoldText: labels?.ArtistDetail.btnExpandBioLabel,
                      foldText: labels?.ArtistDetail.btnCollapseBioLabel
                    }}
                    className='me-0 me-lg-15 pe-0 pe-lg-9 pe-xl-8'
                    lineClamp={8}
                    marginBottom='mb-5'
                  />
                </Col>
              </Row>
            </Container>
          </main>
          <Separator noMarginBottom />
        </>
      }
      <section>
        <Container className='px-5 px-md-7 px-xl-8 '>
          <Row className='mt-0'>
            <Col className='mt-0'>
              <CatalogueArtworkView />
              <ArtistGalleries
                title={CMSProps.pro2_grp1_title_gallery}
                artistId={id}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

const ArtistHeader = styled.section<any>`
  background-color: var(--bs-mch-black);
  position: relative;

  .artist-info {
    @media (min-width: ${global.uikitVars.breakpointXl}) {
      position: absolute;
      bottom: var(--spacing-12);
      width: 32%;
    }

    div.h1,
    h1 {
      color: var(--bs-mch-white);
    }
  }
`

export default ArtistDetail
